// test1850
(1850 && 0);
